// scheme.service.ts
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, tap, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class SchemeService {
  private selectedScheme: any;
  private phasesData: any = null;
  constructor(private api: ApiService,) { }

  setScheme(scheme: any) {
    this.selectedScheme = scheme;
  }

  getScheme() {
    return this.selectedScheme;
  }
  getProposalById(id: number): Observable<any> {
    return this.api.getAPI('/master/proposals/').pipe(
      map((res: any) => {
        const proposals = Array.isArray(res) ? res : res.data || [];
        return proposals.find((p: any) => p.id == id); // use == for leniency
      }),
      catchError(error => {
        console.error('Error in getProposalById:', error);
        return throwError(() => error);
      })
    );
  }

  setPhases(phases: any) {
    this.phasesData = phases;
  }

  getPhases() {
    return this.phasesData;
  }

}
